import type { ComponentProps } from 'react';
import React from 'react';
import type { Nullable } from 'corgi-types';

import Carousel from 'common/components/Carousel';
import { Grid, GridItem } from 'common/components/Grid';
import { Card } from './Card';

const CAROUSEL_SLIDE_CONFIG = {
  slideGap: [16, 24, 24, 32],
  width: [212, 204, 204, 292],
};

interface CardCarouselLayoutProps {
  title: Nullable<string>;
  titleId: string;
  items: Array<Omit<ComponentProps<typeof Card>, 'index'>>;
}

export const CardCarouselLayout = ({ title, titleId, items }: CardCarouselLayoutProps) => {
  const { slideGap, width } = CAROUSEL_SLIDE_CONFIG;

  return (
    <Grid data-corgi-id="card-grid" as="section" {...(title ? { 'aria-labelledby': titleId } : {})}>
      <GridItem>
        <Carousel title={title ?? undefined} titleId={titleId} slideGap={slideGap} withTopControls>
          {items.map((item, index) => (
            <div key={index}>
              <Card index={index} width={width} {...item} />
            </div>
          ))}
        </Carousel>
      </GridItem>
    </Grid>
  );
};
